module.exports = __webpack_public_path__ + "static/media/thewest-digital-hero-variation-eofy-banner.1f0116b7.png";